DialogController = App.loadClass 'core::Angular/DialogController'

class exports.CropResidueRemovedController extends DialogController
    constructor: (@scope, @transitions, @modalInstance, @service) ->
        super(@scope, @transitions, @modalInstance)
        @scope.service = @service
        @scope.getYieldUnit = @getYieldUnit

        @previousValues = {
            current_crop_residue_removed: @service.fpcResult.data.current_crop_residue_removed
            previous_crop_residue_removed: @service.fpcResult.data.previous_crop_residue_removed
            selected_previous_crop: @service.fpcResult.data.selected_previous_crop
            previous_crop_yield: @service.fpcResult.data.previous_crop_yield
        }

    getYieldUnit: () =>
        return null if not @service.fpcResult.data.selected_previous_crop

        units = @service.allCrops.find((crop) =>
            return crop.name is @service.fpcResult.data.selected_previous_crop
        ).yield_unit

        return {
            'short_ton / acre': 'ton/ac'
            'bushel / acre': 'bu/ac'
            'lb / acre': 'lb/ac'
            'cwt / acre': 'cwt/ac'
        }[units]

    save: () ->
        @service.save(@service.state.params.id)
        @modalInstance.dismiss('cancel')

    cancel: () ->
        @service.fpcResult.data.current_crop_residue_removed = @previousValues.current_crop_residue_removed
        @service.fpcResult.data.previous_crop_residue_removed = @previousValues.previous_crop_residue_removed
        @service.fpcResult.data.selected_previous_crop = @previousValues.selected_previous_crop
        @service.fpcResult.data.previous_crop_yield = @previousValues.previous_crop_yield
        @modalInstance.dismiss('cancel')
